<template>
  <div>
    <v-card class="border-r-0 elevation-0">
      <v-card-text class="pa-0">
        <v-layout row wrap align-center>
          <v-btn flat fab small color="grey darken-4" @click="$router.push({ path: '/tickets' })">
            <v-icon>home</v-icon>
          </v-btn>
          <span>Tickets</span>
          <v-spacer></v-spacer>
          <v-btn flat color="teal" dark @click="$router.push({ path: '/tickets/list' })">Ticket List</v-btn>
          <v-btn flat color="teal" dark @click="$router.push({ path: '/tickets/feedback' })">Feedback</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
    <router-view></router-view>
  </div>
</template>
<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import ticketStore from "./store.js";

export default {
  name: "ticket",
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule("ticket", ticketStore);
  }
};
</script>
